module.exports = __webpack_public_path__ + "img/thumbsup-fill.68437493.svg";